import type { BaseSlideProps, SplitContent } from './SlideLayout.types';
import { inlineMarkdown } from '@/lib/markdown';

export function SplitSlide({ title, content, accentColor }: BaseSlideProps) {
  const { left, right } = content as SplitContent;

  return (
    <div
      className="slide-content animate-fade-in-up"
      style={{ '--color-accent': accentColor } as React.CSSProperties}
    >
      <h2 className="text-4xl font-serif font-bold mb-8 accent-text">
        {title}
      </h2>

      <div className="split-layout">
        {/* Left column */}
        <div className="space-y-4">
          {left.type === 'narrative' && left.text && (
            <div className="prose prose-lg">
              {left.text.split('\n\n').map((paragraph, idx) => (
                <p key={idx} className="mb-4 text-slate-700 dark:text-slate-300 leading-relaxed"
                   dangerouslySetInnerHTML={{ __html: inlineMarkdown(paragraph.trim()) }} />
              ))}
            </div>
          )}
        </div>

        {/* Right column */}
        <div className="space-y-4">
          {right.type === 'comparison' && right.items && (
            <div className="space-y-4">
              {right.items.map((item, idx) => (
                <div key={idx} className="card">
                  <h3 className="font-serif font-semibold text-lg mb-2 accent-text">
                    {item.label}
                  </h3>
                  <p className="text-slate-600 dark:text-slate-400 text-sm"
                     dangerouslySetInnerHTML={{ __html: inlineMarkdown(item.description) }} />
                </div>
              ))}
            </div>
          )}

          {right.type === 'visual' && (
            <div className="card accent-border-left text-center py-12">
              <p className="text-slate-400 italic">
                {right.description || 'Visual placeholder'}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
